module.exports = __webpack_public_path__ + "media/images/menu_background-92b22b2adc51b675e6e0a3a8c8c28c52.jpg";